import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "smallArrowRightGray",
  "use": "smallArrowRightGray-usage",
  "viewBox": "0 0 26 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 19\" id=\"smallArrowRightGray\">\n  <style>\n    #smallArrowRightGray .st0{fill:none;stroke:#C1B6B0;stroke-miterlimit:10}\n  </style>\n  <path class=\"st0\" d=\"M16.2 18.7l5.6-5.7M16 .8l9 8.7H0\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol